// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/styles/progallery-svg-font-icons.scss
// module id = 143
// module chunks = 0